import React from "react";
import IconDevreembolso from "../componentsStyled/icon/Icondevreembolso";
import { Box, Button, Modal } from "@mui/material";

interface ModalConcluidoProps {
  isOpen: boolean;
  children?: React.ReactNode;
  onRequestClose: () => void;
}

const ModalConcluido: React.FC<ModalConcluidoProps> = ({ isOpen, onRequestClose }) => {
  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      sx={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        padding: 1,
        width: 300,
        height: "fit-content",
        bgcolor: "#fff",
        boxShadow: 24,
        "& .MuiBackdrop-root": { backgroundColor: "transparent" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        borderRadius: 10,
      }}>
      <Box>
        <IconDevreembolso width={60} />
        <Box marginY={2}>
          <p>
            <strong className="blue">Solicitação Concluída!</strong>
          </p>
        </Box>

        <Box marginY={2}>
          <p>
            A sua solicitação de Devolução foi concluída. Qualquer problema ou inconsistência, entre em contato pelo <strong>site</strong>, pelo nosso{" "}
            <strong>SAC: (11) 5196-9892 </strong>
            ou email de contato: <strong>sac@kappa.com.br</strong>
          </p>
        </Box>

        <Button onClick={onRequestClose}>Voltar</Button>
      </Box>
    </Modal>
  );
};

export default ModalConcluido;
